var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c("div", { staticClass: "transactions-history" }, [
        _c(
          "div",
          { staticClass: "transactions-history-page acc-page-holder" },
          [
            _vm.accountSummaryFlow
              ? [
                  !_vm.mobileBigAndBelow
                    ? _c("h1", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.TransactionHistory.TransactionHistory"
                            )
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mobileBigAndBelow && _vm.brandTemplate !== "generic_2"
                    ? _c(
                        "div",
                        { staticClass: "account-heading" },
                        [
                          _c("icon", { attrs: { name: "icon-tx-history" } }),
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Account.TransactionHistory.TransactionHistory"
                              )
                            )
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            !_vm.accountSummaryFlow
              ? [
                  _c("h1", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.TransactionHistory.TransactionHistory")
                      )
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.loader
              ? _c("div", { staticClass: "loading" }, [_c("dots-loader")], 1)
              : _vm._e(),
            _vm._v(" "),
            !_vm.loader
              ? _c("div", { staticClass: "caca" }, [
                  _c("div", { staticClass: "calendar_holder" }, [
                    _vm.brandTemplate !== "generic_2"
                      ? _c(
                          "div",
                          {
                            class: [
                              "transactions-filter datefilter",
                              { active: _vm.filterExpanded }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.toggleFilter()
                              }
                            }
                          },
                          [
                            _c("div", [
                              _c("div", { staticClass: "date_range_text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Account.TransactionHistory.History")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "date_range" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(
                                      _vm.dateFrom,
                                      _vm.dateFormats.longDate
                                    )
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.$t(
                                        "Account.TransactionHistory.History.To"
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm._f("moment")(
                                        _vm.dateTo,
                                        _vm.dateFormats.longDate
                                      )
                                    )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Account.TransactionHistory.Filter")
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.brandTemplate === "generic_2"
                      ? _c("div", { staticClass: "daterange_holder" }, [
                          _c(
                            "div",
                            {
                              staticClass: "btn-date",
                              class: { active: _vm.calendarDateFrom },
                              on: {
                                click: function($event) {
                                  return _vm.showCalendarDateFrom()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "headhint" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.TransactionHistory.History.DateFrom"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "date_from_to" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(
                                      _vm.dateFrom,
                                      _vm.dateFormats.longDateWitDayName
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "icon_calendar" })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn-date",
                              class: { active: _vm.calendarDateTo },
                              on: {
                                click: function($event) {
                                  return _vm.showCalendarDateTo()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "headhint" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Account.TransactionHistory.History.To"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "date_from_to" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(
                                      _vm.dateTo,
                                      _vm.dateFormats.longDateWitDayName
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "icon_calendar" })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterExpanded
                      ? _c("div", { staticClass: "calendar-container" }, [
                          _vm.brandTemplate !== "generic_2"
                            ? _c("div", { staticClass: "calendar-buttons" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-date",
                                    class: { active: _vm.calendarDateFrom },
                                    on: {
                                      click: function($event) {
                                        return _vm.showCalendarDateFrom()
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "headhint" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Account.TransactionHistory.History.DateFrom"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "date_from_to" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.dateFrom,
                                            _vm.dateFormats.longDateWitDayName
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-date",
                                    class: { active: _vm.calendarDateTo },
                                    on: {
                                      click: function($event) {
                                        return _vm.showCalendarDateTo()
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "headhint" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Account.TransactionHistory.History.To"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "date_from_to" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.dateTo,
                                            _vm.dateFormats.longDateWitDayName
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "calendar" },
                            [
                              _vm.calendarDateFrom
                                ? _c("v-date-picker", {
                                    attrs: {
                                      max: _vm.dateToFormated,
                                      "full-width": true,
                                      "no-title": true,
                                      locale: _vm.currentLocale
                                    },
                                    model: {
                                      value: _vm.dateFromFormated,
                                      callback: function($$v) {
                                        _vm.dateFromFormated = $$v
                                      },
                                      expression: "dateFromFormated"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.calendarDateTo
                                ? _c("v-date-picker", {
                                    attrs: {
                                      min: _vm.dateFromFormated,
                                      max: _vm.dateMaxFormated,
                                      "full-width": true,
                                      "no-title": true,
                                      locale: _vm.currentLocale
                                    },
                                    model: {
                                      value: _vm.dateToFormated,
                                      callback: function($$v) {
                                        _vm.dateToFormated = $$v
                                      },
                                      expression: "dateToFormated"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "apply" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { "x-large": "" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.fetchHistoryTransactions()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Account.TransactionHistory.Apply"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  !_vm.accountSummaryFlow && _vm.noOfPages > 1
                    ? _c(
                        "div",
                        { staticClass: "select-page" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { disabled: _vm.page === 0 },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.fetchHistoryTransactions("minus")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.TransactionHistory.History.Previous"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.page === _vm.noOfPages - 1
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.fetchHistoryTransactions("plus")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.TransactionHistory.History.Next"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.filterExpanded
                    ? _c("div", { staticClass: "txtable-wrapper" }, [
                        !_vm.loader
                          ? _c(
                              "table",
                              { staticClass: "txtable" },
                              [
                                !_vm.isMobile
                                  ? _c("tr", { staticClass: "tablehead" }, [
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.TransactionHistory.History.Date"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.TransactionHistory.History.Name"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.TransactionHistory.History.DebitAmount"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.TransactionHistory.History.CreditAmount"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.TransactionHistory.History.CurrentBalance"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.shouldDisplayPromoBalance
                                        ? _c("th", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.TransactionHistory.History.PromoBalance"
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.TransactionHistory.History.Reference"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isMobile
                                  ? _c("tr", { staticClass: "tablehead" }, [
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.TransactionHistory.History.Date"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      !_vm.isAnyReference
                                        ? _c("th", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.TransactionHistory.History.Name"
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isAnyReference
                                        ? _c("th", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.TransactionHistory.History.Name"
                                                  )
                                                ) + " /"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.TransactionHistory.History.Reference"
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.TransactionHistory.History.Mobile.DebitCredit"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Account.TransactionHistory.History.CurrentBalance"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.shouldDisplayPromoBalance
                                          ? _c("span", [_vm._v(_vm._s("/"))])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.shouldDisplayPromoBalance
                                          ? _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Account.TransactionHistory.History.PromoBalance"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.transactions, function(
                                  transaction,
                                  index
                                ) {
                                  return !_vm.isMobile
                                    ? _c(
                                        "tr",
                                        {
                                          key: index,
                                          staticClass: "transactions-body"
                                        },
                                        [
                                          _c("td", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    transaction.TransactionTime,
                                                    _vm.dateFormats.longDate
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    transaction.TransactionTime,
                                                    _vm.dateFormats.longTime
                                                  )
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                transaction.TransactionName
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                transaction.AmountDebit
                                                  ? "-"
                                                  : ""
                                              ) +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    transaction.AmountDebit
                                                  )
                                                )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("currency")(
                                                  transaction.AmountCredit
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("currency")(
                                                  transaction.Balance
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.shouldDisplayPromoBalance
                                            ? _c(
                                                "th",
                                                {
                                                  staticClass: "txtable__promo"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        transaction.PromoAmount ||
                                                          0
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              class: [
                                                {
                                                  "no-reference": !_vm.isAnyReference
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    transaction.Reference || "-"
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.transactions, function(
                                  transaction,
                                  index
                                ) {
                                  return _vm.isMobile
                                    ? _c(
                                        "tr",
                                        {
                                          key: index,
                                          staticClass: "transactions-body"
                                        },
                                        [
                                          _c("td", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    transaction.TransactionTime,
                                                    _vm.dateFormats.longDate
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    transaction.TransactionTime,
                                                    _vm.dateFormats.longTime
                                                  )
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  transaction.TransactionName
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.isAnyReference
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      transaction.Reference
                                                    )
                                                  )
                                                ])
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      transaction.AmountDebit
                                                        ? "-"
                                                        : ""
                                                    ) +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          transaction.AmountDebit
                                                        )
                                                      )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        transaction.AmountCredit
                                                      )
                                                    )
                                                  )
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    transaction.Balance
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.shouldDisplayPromoBalance
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "txtable__promo"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          transaction.PromoAmount ||
                                                            0
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.transactions || _vm.transactions.length === 0
                          ? _c("div", { staticClass: "no-data" }, [
                              _vm._v(_vm._s(_vm.$t("Account.Table.NoData")))
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.filterExpanded &&
                  _vm.accountSummaryFlow &&
                  _vm.noOfPages > 1
                    ? _c(
                        "div",
                        { staticClass: "select-page" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn",
                              attrs: { disabled: _vm.page === 0 },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.fetchHistoryTransactions("minus")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.TransactionHistory.History.Previous"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary-btn",
                              attrs: {
                                disabled: _vm.page === _vm.noOfPages - 1
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.fetchHistoryTransactions("plus")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Account.TransactionHistory.History.Next"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.accountSummaryFlow && !_vm.filterExpanded
          ? _c("div", { staticClass: "responsible-gaming-page" }, [
              _c("span", { on: { click: _vm.responsibleGaming } }, [
                _vm._v(_vm._s(_vm.$t("Account.ResponsibleGaming")))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.brandTemplate === "generic_2"
          ? _c(
              "div",
              { staticClass: "acc_page_bgr_img" },
              [_c("icon", { attrs: { name: "icon-tx-history" } })],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9c1f942", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9c1f942","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountHistoryTransactionsComponent.vue
// module id = null
// module chunks = 